<div class="row" [formGroup]="clientName">
  <div class="col-md-6">
    <uni-form-field>
      <uni-label>Nombre(s) del Asegurado:</uni-label>
      <input uniInput formControlName="firstName" />
    </uni-form-field>
  </div>
  <div class="col-md-6">
    <uni-form-field>
      <uni-label>Apellido(s) del Asegurado:</uni-label>
      <input uniInput formControlName="lastName" />
    </uni-form-field>
  </div>
</div>
